// Feature flags — hide in-progress features from the UI without removing code.
//
// Pattern:
//   - Code (pages, modals, hooks) stays in the repo.
//   - This file controls whether the feature is wired into routes + sidebar.
//   - Flip a flag to `true` when the feature is ready to ship.
//   - On a final pre-release pass, flip the whole batch to unlock everything.
//
// To gate a sidebar section: add `flag: '<name>'` to the SECTIONS entry in
// `frontend/src/lib/sections.js`. The section disappears until the flag is on.
//
// To gate a route: wrap the <Route> in `{FEATURES.<name> && <Route ... />}` in
// `frontend/src/App.js`. Direct visits to the URL fall through to the catch-all
// redirect to "/".

import { isBetaEnabled } from '@/v2/featureFlags';

export const FEATURES = {
  documents: false,  // F-007 Document Hub — design WIP, ship later as an update
  driveSync: true,   // V2 client-side Drive sync (náhrada Supabase) — Client ID v .env, test naživo
  bankMatch: false,  // P6 Fio fetch (online stiahnutie pohybov) — CSV import ide vždy, Fio tab len keď true

  // Zákazky (Dielňa) — dozrievajúca V2 feature. Viaže sa na V2 beta prepínač, NIE na
  // vlastný flag: keď je V2 beta ON (app2/dev), sekcia je v menu; v prode je OFF a user
  // ju nevidí. Bez tohto by sa rozrobená vec objavila v produkčnom menu.
  zakazky: isBetaEnabled(),

  // Sémantické hľadanie (AI vektorový RAG, on-device) — dozrievajúca V2 feature. Rovnaký beta
  // gate ako zakazky: app2/dev ON, prod OFF kým sa nedoladí vstupný bod (Jožko) + model install.
  search: isBetaEnabled(),

  // Automatizácie (Blueprint Engine UI — Súhlasy/História) — NEdedí V2 beta. Overené
  // 2026-08-28: cf-deploy-prod.yml (app.todue.sk) nastavuje REACT_APP_V2_BETA=1 od
  // cutoveru 2026-08-09 ROVNAKO ako staging (cf-deploy-v2.yml) — `isBetaEnabled()` je
  // teda TRUE aj v produkcii, nie len na app2/dev, ako komentáre pri zakazky/search
  // vyššie predpokladajú (tie sú dnes tiež naostro viditeľné, nedotknuté — mimo rozsahu
  // tejto zmeny). Automatizácie nemajú grant-flow ani žiadny reálny workflow_template,
  // preto vlastný default-false flag, nezávislý od V2 beta stavu — zapne ho Daniel ručne.
  automations: false,

  // Poradca (vyhľadávanie vo vedomostnej knižnici, /poradca) — nie je v ostrej (patrí do GROW,
  // Daniel 2026-10-07). Kód + stránka ostávajú v repe, flag riadi route aj položku v menu.
  poradca: false,
};
